module.exports = __webpack_public_path__ + "static/irregular_engineering-857b172e7140cef23930a986f37c68da.png";